var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTriarioDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_343",
    "data-name": "Grupo 343",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 202.053,
    height: 84.594,
    viewBox: "0 0 202.053 84.594",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_45",
    "data-name": "Rect\\xE1ngulo 45",
    width: 202.053,
    height: 84.594,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_36",
    "data-name": "Trazado 36",
    d: "M87.211,79.743a.553.553,0,0,0-.416-.191H80.113a.573.573,0,0,0-.416.954l10.97,12.43a.582.582,0,0,1,.042.712L79.874,109.365a.572.572,0,0,0,.457.9h6.7a.556.556,0,0,0,.458-.245L98.683,93.514a.581.581,0,0,0-.043-.707Z",
    transform: "translate(-52.7 -52.7)",
    fill: "#ff433f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_37",
    "data-name": "Trazado 37",
    d: "M235.332,95.755h3.94v25.332h-7.6V101.146Z",
    transform: "translate(-153.473 -63.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M409.95,95.755h3.94v25.332h-7.6V101.146Z",
    transform: "translate(-269.15 -63.434)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M439.5,107.288a13.426,13.426,0,1,1,13.426,13.375A13.278,13.278,0,0,1,439.5,107.288m19.253,0a5.828,5.828,0,1,0-5.826,5.979,5.682,5.682,0,0,0,5.826-5.979",
    transform: "translate(-291.148 -62.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_40",
    "data-name": "Trazado 40",
    d: "M131.981,84.062l5.344,6.148a.964.964,0,0,1,.072,1.173l-4.634,6.848V99c0,7.093,2.888,10.082,12.818,9.069v-6.891c-3.344.2-5.218,0-5.218-2.179V90.032h5.218v-7.3h-5.218V75.971h-2.909Z",
    transform: "translate(-87.432 -50.328)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_41",
    "data-name": "Trazado 41",
    d: "M292.137,94.622v25.332h-5.518l-2.082-2.381a9.515,9.515,0,0,1-7.549,3.091c-6.637,0-12.109-5.826-12.109-13.375s5.472-13.376,12.109-13.376A9.515,9.515,0,0,1,284.537,97l1.607-2.381Zm-7.6,12.666a6.031,6.031,0,1,0-6.029,6.181,5.785,5.785,0,0,0,6.029-6.181",
    transform: "translate(-175.471 -62.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_42",
    "data-name": "Trazado 42",
    d: "M191.444,96.014l-1.786,1.595-1.592-1.595h-5.758v25.332h7.6V103.31h3.2l4.094-6.044V96.014Z",
    transform: "translate(-120.771 -63.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_43",
    "data-name": "Trazado 43",
    d: "M366.062,96.014l-1.786,1.595-1.592-1.595h-5.758v25.332h7.6V103.31h3.2l4.094-6.044V96.014Z",
    transform: "translate(-236.448 -63.605)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_44",
    "data-name": "Trazado 44",
    d: "M229.421,65.7a4.56,4.56,0,1,1,4.56,4.56,4.606,4.606,0,0,1-4.56-4.56",
    transform: "translate(-151.982 -40.505)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_45",
    "data-name": "Trazado 45",
    d: "M404.039,65.7a4.56,4.56,0,1,1,4.56,4.56,4.606,4.606,0,0,1-4.56-4.56",
    transform: "translate(-267.659 -40.505)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTriarioDark);
export default __webpack_public_path__ + "static/media/logoTriarioDark.ae68bcda315c00aacfe780398f541e00.svg";
export { ForwardRef as ReactComponent };